import url from "../../url";

export type Tab = {
  id: string | number;
  name: string;
  url: string;
};

export interface ITabsProps {
  tabs: Tab[];
  onClick: (url: string) => void;
}

enum TRANSACTION_ENUMS {
  DEPOSIT,
  WITHDRAW,
}

export const TRANSACTION_TABS: Tab[] = [
  {
    id: TRANSACTION_ENUMS.DEPOSIT,
    name: "profile.navigation.deposit",
    url: url.routes.profile.transactionDetail("deposit"),
  },
  {
    id: TRANSACTION_ENUMS.WITHDRAW,
    name: "profile.navigation.withdraw",
    url: url.routes.profile.transactionDetail("withdrawal"),
  },
];
